const colors = {
    PRIMARY: "#181021",
    SOFT_GREEN: "#cdded6",
    LIGHT_GREEN: "#C9DFD5",
    GREEN: "#93c052",
    DARK_TURQUOISE: "rgb(27,68,133)",
    BLACK_BRAND: "#181021",
    BLACK_80: "#181021",
    BLACK_70:"#74707945",
    BLACK_60: "#747079",
    BLACK_40: "#ccc",
    BLACK_20: '#ECECEC',
    BLACK_10: '#2022260A',
    BLACK_30 : '#ddd',
    GRAY_LIGHT: "#ededee",
    WHITE: "#ffffff",
    GRAY: "#dcdbdd",
    GRAY_DARK: "#97949a",
    BLACK_100: "#17111f",
    RED: "#C55E5E",
    YELLOW: "#ffee00",
    TRANSPARENT: "#00000000",
    BLUE : '#173d85',
    DARK_YELLOW : '#BA9D26',
    TURQUOISE : '#23BABF'
  }

  export default colors